import { type UserState, useSelector } from '@tunasong/redux'

export const useCurrentUser = (): UserState => {
  const user = useSelector(state => state.user)
  return user
}
